<template>
  <v-row>
    <v-col>
      <v-card
          style="width: 100%;
    height: calc(100vh - 125px);
    display: flex;
    flex-direction: column;
    min-height: 0; padding: 0px !important; box-shadow: none"
          class="flex-grow-1 overflow-y-auto pa-4">
        <v-calendar
            ref="calendar"
            v-model="focus"
            color="blue"
            :weekday-format="myDayFormat"
            :month-format="myMonthFormate"
            :events="events"
            :event-color="getEventColor"
            :event-ripple="false"
            type="day"
            interval-height="20"
            :interval-count="24*4"
            :interval-minutes="15"
            :interval-format="myIntervalFormat"
            :weekdays="weekdayOrder"
            event-more-text="Mehr anzeigen"
            @click:event="({ nativeEvent, event }) => $emit('click-event', event)"
            @mousedown:time="startTimeTimeLine"
            @mousemove:time="mouseMoveTimeLine"
            @mouseup:time="endDragTimeLine"
            @mouseleave.native="cancelDragTimeLine"
        >
          <template v-slot:day-label-header="{day, present, month, year, weekday}">
            <v-row class="m-0" style="margin-top: -6px !important;">

            </v-row>
          </template>
          <template v-slot:event="{ event, timed, eventSummary }" >
            <div  :class="[event.id !== 'created' ? 'clickable' : '', 'v-event-draggable', event.id === focusedEvent ? 'event-focused' : '']">
              <!--component :is="{ render: eventSummary }"></component-->
              <div class="v-event-summary" style="color: white">
                <v-row v-if="event.task !== event.name" style="margin: 0; flex-grow: 0">
                  <v-col cols="10" class="p-0">
                    <p :class="{'mb-0': true,  'ml-1': true, 'planned-for': true, 'event-description': true}"
                       :style="{'color': 'white'}">{{event.task}}</p>
                  </v-col>
                </v-row>
                <v-row v-if="event.task" style="margin: 0; flex-grow: 0">
                  <v-icon :color="'white'" style="align-items: start; padding-top: 0px;"
                          v-text="'mdi-clipboard-check'">
                  </v-icon>
                  <v-col cols="10" class="p-0">
                    <p :class="{'mb-0': true,  'ml-1': true, 'planned-for': true, 'event-description': true}"
                       style="font-size: 16px; margin-bottom: 0px; padding-top: 1px"><b>{{event.name}}</b></p>
                  </v-col>
                </v-row>
                <v-row v-else style="margin: 0; flex-grow: 0">
                  <v-icon :color="'white'" style="align-items: start; padding-top: 0px;" v-if="event.color !== '#a6a4a4'"
                          v-text="event.color === '#095996' ? 'mdi-umbrella-beach' : event.color === '#b2ea24' ? 'mdi-plus' : 'mdi-account-cancel'">
                  </v-icon>
                  <v-col cols="10" class="p-0">
                    <p :class="{'mb-0': true,  'ml-1': true, 'planned-for': true, 'event-description': true}"
                       style="font-size: 16px; margin-bottom: 0px; padding-top: 1px"><b>{{event.name}}</b></p>
                  </v-col>
                </v-row>
                <p v-if="event.description" style="margin-bottom: 2px">{{event.description}}</p>
              </div>
            </div>
            <div
                v-if="timed && event.id === focusedEvent"
                class="v-event-drag-top"
                @mousedown.stop="onExtendTop(event)"
            ></div>
            <div
                v-if="timed && event.id === focusedEvent"
                class="v-event-drag-bottom-2"
                @mousedown.stop="onExtendBottom(event)"
            ></div>
          </template>
          <template v-slot:interval="{weekday, time}" >
            <div :style="{'background-color': getBackgroundColor((weekday + 6) % 7, time), 'height': '20px'}" style="color: white; font-weight: bold; padding-left: 8px" @click="log(e)">
              {{getRbName((weekday + 6) % 7, time)}}
            </div>
          </template>
        </v-calendar>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import {getUid} from "@/shared/crypto";
import * as events from "events";

export default {
  name: "DayView",
  props: {
    date: {
      type: String,
      default () {
        return new Date().toISOString().substr(0, 10);
      }
    },
    currentMita: {
      type: String,
      default: () => undefined
    },
    focusedEvent: {
      type: String,
      default: () => '',
    },
    mitasFlat: {
      type: Array,
      default: () => []
    },
    holidayLohn: {
      type: String,
      default: ""
    },
    overview: {
      type: Object,
      default: {
        user_day: {
          soll: 0.0,
              ist: 0.0,
              valence: 0.0,
              has_rufbereitschaft: false,
        },
        time_blocks: [],
            time_surcharges: 0.0,
            ueb_performed: 0.0,
            roundings: 0.0,
            rb: "",
            surcharges: [],
      }
    }
  },
  mounted() {
    this.focus = this.date.substr(0, 10);
    this.$refs.calendar.updateTimes();
    this.currentMonth = this.$refs.calendar.parsedValue.month;
    this.currentYear = this.$refs.calendar.parsedValue.year;
    this.$refs.calendar.scrollToTime('06:45')
    this.events = [];
  },
  watch: {
    date: function (newDate) {
      this.focus = newDate.substr(0, 10);
      this.$nextTick(() => {
        this.currentMonth = this.$refs.calendar.parsedValue.month;
        this.currentYear = this.$refs.calendar.parsedValue.year;
        this.events = [];
        this.$refs.calendar.updateTimes();
      });
    },
    overview: function () {
      this.calculateEvents();
      this.$refs.calendar.updateTimes();
    },
    currentMita: function () {
      this.$nextTick(() => {
        this.events = [];
      });
    },
    events: function () {
      this.$nextTick(() => {
      });
    },
  },
  computed: {
  },
    data: () => ({
    focus: new Date().toISOString().substr(0, 10),
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    events: [],
    currentMonth: 0,
    currentYear: 0,
    start: null,
    end: null,
    selectedDay: "",

    // free modify multiple
    showModify: false,
    modifyDate: "",
    modifyDateObject: {},
    timeSelectionEvents: [],
    // currently edited event
    createEventTimeLine: null,
    // start time of currently edited event
    createStartTimeLine: null,
    // end time of dragged event
    extendOriginalTimeLine: null,
    // dragging
    dragEventTimeline: null,

      extendOriginal: null,
      extendTop: null,
      extendBottom: null,
      dragTime: null,

    }),
  methods: {
    log(e) {
    },
    scrollTo(index) {
      let scrollEvent = this.events[index];
      this.$refs.calendar.scrollToTime(`${scrollEvent.start.getHours()}:${scrollEvent.start.getMinutes()}`);
    },
    isSelected(year, month, day) {
      return this.selectedDay === new Date(year, month-1, day, 12).toISOString().substring(0, 10);
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    myIntervalFormat({time}) {
      if (time.substring(3) === "00") {
        return time
      }
      return ""
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.createEventTimeLine
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event === this.createEvent
              ? `rgba(${r}, ${g}, ${b}, 0.7)`
              : `rgba(${r}, ${g}, ${b}, 0.9)`
    },
    isFuture(day, present, month, year) {
      if (present) {
        return false
      }
      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      let date = new Date(year, month-1, day);
      return date > today;
    },
    roundToDigits (number, digits) {
      const roundTo = Math.pow(10, digits)
      return Math.round(number * roundTo) / roundTo
    },
    calculateEvents() {
      let events = [];
        let current = this.overview.time_blocks;
        let e = null;
        let eF = null;
        for (let j = 0; j < current.length; j++) {
          let split = current[j];
            let start = new Date(`${this.overview.user_day.date}T${split.von}:00`)
            let end = new Date(`${this.overview.user_day.date}T${split.bis}:00`)
            let name = split.title;
            let description = split.legr;
            let task = split.type === "ARBL" ?  split.task : "";
            let holidayOverwrite = split.task === this.holidayLohn;
            let color = "#000";
            switch (split.type) {
              case "ARBL":
                color = "#328f33"; // 016d03
                if (eF != null) {
                  events.push(eF);
                  eF = null;
                }
                events.push({
                  id: split.id,
                  name: name,
                  task: task,
                  description: description,
                  start: start,
                  end: end,
                  color: color,
                  timed: true,
                })
                break;
              case "PAUS":
                color = "#a6a4a4";
                events.push({
                  id: split.id,
                  name: name,
                  description: description,
                  start: start,
                  end: end,
                  color: color,
                  timed: true,
                })
                break;
              case "FEHL":
                color = "#ea5324"
                if (holidayOverwrite) {
                  color = "#095996";
                }
                  events.push({
                        id: split.id,
                        name: name,
                        start: start,
                        end: end,
                        color: color,
                        timed: true,
                      }
                  )
                break;
            }
        }
        if (eF != null) {
          events.push(eF);
          eF = null;
        }
        // todo remove pause entries if felzeit contains them
      this.events = events;
    },
    getBackgroundColor(index, start) {
      let color = 'rgba(232,232,232,0.37)'
      if (this.overview.user_time) {
        try {
          let splits = this.overview.user_time.soll_zeit.split("-");
          let rbTopLevelSplits = this.overview.rb.split("; ");
          for (let i = 0; i < rbTopLevelSplits.length; i++) {
            let rbSplits = rbTopLevelSplits[i].split(" - ");
            if (rbSplits[0] <= start && (rbSplits[1] > start || rbSplits[1] === "00:00")) {
              return 'rgba(255,188,10,0.79)'
            }
          }
          if (splits[0] <= start && splits[1] > start) {
            color = '#fff'
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        color = '#fff'
      }
      return color
    },
    getRbName(index, start) {
      let name = ''
      if (this.overview.user_time) {
        try {
          let splits = this.overview.user_time.soll_zeit.split("-");
          let rbTopLevelSplits = this.overview.rb.split("; ");
          for (let i = 0; i < rbTopLevelSplits.length; i++) {
            let rbSplits = rbTopLevelSplits[i].split(" - ");
            if (rbSplits[0] === start) {
              return 'RB ' + rbTopLevelSplits[i];
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
      return name
    },
    startDragTimeline({event, timed}) {
      if (event && timed && event.eventType !== "new") {
        return
      }
      if (event && timed) {
        this.dragEventTimeline = event;
        this.dragTime = null;
        this.extendTop = null;
        this.extendBottom = null;
      }
    },
    startTimeTimeLine (tms) {
      if (!this.currentMita) {
        return;
      }
      const mouse = this.roundTime(this.toTime(tms));
      let realTime = this.toTime(tms);
      if (this.extendBottom && this.dragTime === null) {
        const start = this.extendBottom.start;
        this.dragTime = realTime - start;
        return;
      } else if (this.extendTop && this.dragTime === null) {
        const end = this.extendTop.end;
        this.dragTime = end - realTime;
        return;
      }
      for (let i = 0; i < this.events.length; i++) {
        let blocked = this.events[i];
        if ((realTime < blocked.end)  &&  (realTime > blocked.start)) {
          return;
        }
      }

      this.createStartTimeLine = this.roundTime(mouse)
      this.createEventTimeLine = {
        id: getUid(),
        name: `Neuer Abschnitt`,
        color: "#b2ea24",
        start: this.createStartTimeLine,
        end: this.createStartTimeLine,
        timed: true,
        eventType: "new",
      };
      this.events.push(this.createEventTimeLine)
    },
    onExtendBottom (event) {
      this.extendOriginal = { ...event};
      this.extendBottom = event;
      this.dragTime = event.end - this.toTime({
        year: new Date(event.end).getFullYear(),
        month: new Date(event.end).getMonth() + 1,
        day: new Date(event.end).getDate(),
        hour: new Date(event.end).getHours(),
        minute: new Date(event.end).getMinutes(),
      });
    },
    onExtendTop (event) {
      this.extendOriginal = { ...event};
      this.extendTop = event;
      this.dragTime = this.toTime({
        year: new Date(event.start).getFullYear(),
        month: new Date(event.start).getMonth() + 1,
        day: new Date(event.start).getDate(),
        hour: new Date(event.start).getHours(),
        minute: new Date(event.start).getMinutes(),
      }) - event.start;
    },
    mouseMoveTimeLine (tms) {
      if (!this.currentMita) {
        return;
      }
      const mouse = this.toTime(tms)
      if ((this.extendTop || this.extendBottom) && this.dragTime !== null) {
        let extendedEvent = this.extendBottom ? this.extendBottom : this.extendTop;
        const start = extendedEvent.start
        const end = extendedEvent.end
        let newStart = this.extendTop ? this.roundTime(mouse, true) : start;
        let newEnd = this.extendBottom ? this.roundTime(mouse, false) : end;

        let isBlocked = false;
        for (let i = 0; i < this.events.length; i++) {
          let e = this.events[i];
          if (e.id !== extendedEvent.id && ((newStart < e.end)  &&  (newEnd > e.start))) {
            isBlocked = true;
            break
          }
        }
        if (isBlocked) {
          return;
        }
        extendedEvent.start = newStart
        extendedEvent.end = newEnd
      } else if (this.createEventTimeLine && this.createStartTimeLine !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStartTimeLine)
        const max = Math.max(mouseRounded, this.createStartTimeLine)
        for (let i = 0; i < this.events.length; i++) {
          let blocked = this.events[i];
          if (this.createEventTimeLine.id !== blocked.id && blocked.color !== "#a6a4a4" && (min < blocked.end)  &&  (max > blocked.start)) {
            return;
          }
        }
        this.createEventTimeLine.start = min
        this.createEventTimeLine.end = max
      }
    },
    endDragTimeLine () {
      if (!this.currentMita) {
        return;
      }
      if (this.createEventTimeLine) {
        const i = this.events.indexOf(this.createEventTimeLine)
        if (i !== -1) {
          this.events.splice(i, 1)
          let startDate = new Date(this.createEventTimeLine.start);
          let endDate = new Date(this.createEventTimeLine.end);
          let start = `${startDate.getHours().toString().padStart(2, '0')}:${startDate.getMinutes().toString().padStart(2, '0')}`;
          let end = `${endDate.getHours().toString().padStart(2, '0')}:${endDate.getMinutes().toString().padStart(2, '0')}`;
          if (start !== end) {
            this.$emit('create-time-block', {
              start: start,
              end: end,
            });
          }
        }
      }

      if (this.extendBottom || this.extendTop) {
        let extendedEvent = this.extendBottom ? this.extendBottom : this.extendTop;
        let startDate = new Date(extendedEvent.start);
        let endDate = new Date(extendedEvent.end);
        let start = `${startDate.getHours().toString().padStart(2, '0')}:${startDate.getMinutes().toString().padStart(2, '0')}`;
        let end = `${endDate.getHours().toString().padStart(2, '0')}:${endDate.getMinutes().toString().padStart(2, '0')}`;
        this.$emit('extend-time-block', {
          id: extendedEvent.id,
          start: start,
          end: end,
        });
      }

      this.createEventTimeLine = null
      this.createStartTimeLine = null
      this.extendBottom = null
      this.extendTop = null
      this.extendOriginalTimeLine = null
      this.dragTime = null;
      this.dragEventTimeline = null;
    },
    cancelDragTimeLine () {
      // remove the created event if exists
      if (this.createEventTimeLine) {
        const i = this.events.indexOf(this.createEventTimeLine)
        if (i !== -1) {
          this.events.splice(i, 1)
        }
      }
      if (this.extendTop) {
        this.extendTop.start = this.extendOriginal.start;
        this.extendTop.end = this.extendOriginal.end;
      } else if (this.extendBottom) {
        this.extendBottom.start = this.extendOriginal.start;
        this.extendBottom.end = this.extendOriginal.end;
      }
      this.createEventTimeLine = null
      this.createStartTimeLine = null
      this.extendTop = null
      this.extendBottom = null
      this.extendOriginalTimeLine = null
      this.dragTime = null;
      this.dragEventTimeline = null;
    },
    roundTime (time, down = true) {
      const roundTo = 15 // minutes
      const roundDownTime = roundTo * 60 * 1000

      return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
  },
}
</script>

<style scoped>
.v-calendar .v-event {
  pointer-events: none;
}

.clickable-month {
  pointer-events: auto !important;
  padding-left: 4px;
  padding-right: 4px;
}

.clickable {
  pointer-events: auto !important;
  padding: 6px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}

.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

::v-deep .v-event-timed {
  margin-left: 4px;
  margin-right: 4px;
  width: calc(100% - 8px) !important;
}


::v-deep .five-week div.v-calendar-daily_head-day:nth-child(7) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily_head-day:nth-child(8) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily__day:nth-child(7) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .five-week div.v-calendar-daily__day:nth-child(8) {
  display: none;
  height: 0px !important;
  width: 0px !important;
}

::v-deep .v-calendar .v-btn--fab.v-size--default {
  width: 28px;
  height: 28px;
}

::v-deep .v-calendar .v-btn--fab.v-size--default.blue {
  background-color: rgb(99, 194, 222) !important;
  border-color: rgb(99, 194, 222) !important;
}

::v-deep .v-calendar-daily__pane {
  min-height: 100% !important;
}

.event-description {
  flex: 0 0 auto;
  overflow: hidden;
  width: 100%;
  white-space: normal;
  word-break: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  margin-bottom: 2px;
}

.planned-for {
  margin-top: 1px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: normal;
}

.event-extended {
  flex: 0 0 auto;
  margin-bottom: 4px
}

::v-deep .v-list-group__header__prepend-icon {
  margin-right: 0px  !important;
  margin-top: 6px  !important;
}

::v-deep .v-calendar-daily__head {
  display: none;
}

::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 18px !important;
}

.unselectable-text {
  -webkit-user-select: none !important; /* Safari */
  -moz-user-select: none !important; /* Firefox */
  -ms-user-select: none !important; /* IE10+/Edge */
  user-select: none !important; /* Standard */
}

::v-deep .v-calendar .v-event-timed-container {
  margin: 2px !important;
}

.rounded {
  border-radius: 8px !important;
}

.rounded::before {
  border-radius: 8px !important;
}


</style>

<style lang="scss">
.v-event-drag-bottom-2 {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 12px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    bottom: 0px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 32px;
    margin-left: -16px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}



.v-event-drag-top {
  position: absolute;
  left: 0;
  right: 0;
  top: 4px;
  height: 12px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 32px;
    margin-left: -16px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}
</style>

